// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TruoraSettingsForm-module__wrapper___2Yzst","description":"TruoraSettingsForm-module__description___33W4W"};